import { Config } from '../types/configType';
import * as config from 'config/json/remoteConfig.json';

export const getConfig = (): Config | AnyObject => config;
